export enum MessageType {
  User,
  Agent
}